import type { FC } from 'react';
import React, { useEffect } from 'react';

import { Dialog, Icon, Space, Typography } from '@sravni/react-design-system';
import type { DialogProps } from '@sravni/react-design-system/dist/types/components/Dialog';
import { ShieldSafety } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import AuthFormFOS from '@src/components/form/AuthFormFOS';
import { useCardClick } from '@src/components/ProductList/components/Card/useCardClick';
import { sendEvent } from '@src/helpers/analyticsEvents';
import { save } from '@src/services/formbuilder';

import style from './BankruptcyDialog.module.scss';

interface Props extends Pick<DialogProps, 'visible' | 'onClose'> {
  data: { offer: IClientMicrocreditListItem; position: number };
}

const eventCategory = 'Банкротство';
const eventLabel = 'Национальная Служба Списания Долгов|Банкротство';

export const BankruptcyDialog: FC<Props> = ({ visible, onClose, data: { offer, position } }) => {
  const isMobile = useIsMobile();
  const { cardLink } = useCardClick({
    offer,
    position,
  });

  useEffect(() => {
    sendEvent(eventCategory, 'Переход к оформлению заявки', eventLabel);
  }, []);

  const handleOnLogin = async (userData: { name: string; phone: string }) => {
    await save({
      ...userData,
      formId: 278,
      mfo_offer: true,
      BankId: '7778279',
      BankName: 'Национальная Служба Списания Долгов (НССД)',
      offers: [
        {
          BankId: '7778279',
          BankName: 'Национальная Служба Списания Долгов (НССД)',
          productName: 'Банкротство под ключ',
          product_id: '64afd504ee273100272a94b7',
        },
      ],
      ProductType: 'МФО',
      productName: 'Списание долгов',
    });

    sendEvent(eventCategory, 'Отправить заявку', eventLabel);

    onClose(null);
  };

  const handleSend = () => {
    sendEvent(eventCategory, 'Подтвердить телефон', eventLabel);
  };

  return (
    <div className={style.cardWrapper}>
      <Dialog className={style.dialog} visible={visible} onClose={onClose} fullscreen={isMobile}>
        <Dialog.Header>
          <Typography.Heading className={style.dialogHeader} level={3}>
            Бесплатная консультация по&nbsp;списанию долгов
          </Typography.Heading>
        </Dialog.Header>
        <Dialog.Content>
          <Space direction="vertical" size={16}>
            <Space className={style.notion} direction="horizontal" size={12}>
              <div className={style.iconWrapper}>
                <Icon color="green" size={24} icon={<ShieldSafety />} />
              </div>
              <Typography.Text size={14}>
                Опытный юрист <span className="bold">Национальной Службы Списания Долгов (НССД)</span> поможет
                разобраться в вашей ситуации и&nbsp;подскажет, что нужно сделать, чтобы списать долги и сохранить
                имущество
              </Typography.Text>
            </Space>
            <AuthFormFOS
              source="mfo"
              onLogin={handleOnLogin}
              onSend={handleSend}
              fields={['name', 'phone']}
              btnColor="dark"
              btnText="Отправить"
            />
          </Space>
        </Dialog.Content>
      </Dialog>
      <iframe src={cardLink.href} className={style.iframe} />
    </div>
  );
};
